(ns practitest.frontend.testset2.set-instance-parameters
  (:require
   [ajax.core :as ajax]
   [clojure.string :as str]
   [day8.re-frame.http-fx]
   [practitest.frontend.common.i18n :refer [format-translation get-translation]]
   [practitest.frontend.components.icons :as icons]
   [practitest.frontend.components.modal :as modal]
   [practitest.frontend.components.notifications :as notifications]
   [practitest.frontend.components.selector2 :as selector2]
   [practitest.frontend.components2.buttons :as buttons]
   [practitest.frontend.components2.spinners :as spinners]
   [practitest.frontend.routing.backend-routes :as broutes]
   [practitest.frontend.subs :as subs]
   [practitest.frontend.testset2.events :as testset-events]
   [re-frame.core :as re-frame]))

(def ^:private state-key :instance-set-parameters)

(defn- ids->str [selection]
  (if (= selection :_all) "_all" (str/join "," selection)))

(re-frame/reg-event-fx
  ::show-modal
  (fn [{:keys [db]} [_ selection testset-id]]
    {:db (-> db
             (assoc-in [:form-states2 state-key :show-modal?] true)
             (assoc-in [:form-states2 state-key :selection] selection)
             (assoc-in [:form-states2 state-key :testset-id] testset-id))
     :dispatch [::load-params selection testset-id]}))

(re-frame/reg-event-db
  ::hide-modal
  (fn [db _]
    (update db :form-states2 dissoc state-key)))

(re-frame/reg-event-fx
  ::load-params
  (fn [{:keys [db]} [_ selection testset-id]]
    {:db (update db :progress conj ::load-params)
     :http-xhrio
     {:method          :get
      :uri             (broutes/get-url "steps_params#index"
                                        {:project_id (subs/get-current-project-id db)}
                                        {:ids    (ids->str selection)
                                         :set_id testset-id})
      :format          (ajax/json-request-format)
      :response-format (ajax/json-response-format {:keywords? true})
      :on-success      [::params-loaded]
      :on-failure      [::params-load-error]}}))

(re-frame/reg-event-db
  ::params-loaded
  (fn [db [_ response]]
    (if-not (get-in db [:form-states2 state-key :show-modal?])
      (update db :progress disj ::load-params)
      (let [params-list (sort-by :name (vals (:params response)))]
        (-> db
            (update :progress disj ::load-params)
            (assoc-in [:form-states2 state-key :params] params-list)
            (assoc-in [:form-states2 state-key :batch-name] (:batch_name response))
            (assoc-in [:form-states2 state-key :instance-ids] (:instance_ids response))
            (assoc-in [:form-states2 state-key :enterprise-only?] (boolean (:non_enterprise response)))
            (assoc-in [:form-states2 state-key :param-values]
                      (reduce (fn [acc {:keys [name val]}]
                                (assoc acc name (or val "")))
                              {}
                              params-list)))))))

(re-frame/reg-event-fx
  ::params-load-error
  (fn [{:keys [db]} [_ error]]
    (let [error-response (get-in error [:response])
          error-message  (or (:error error-response)
                             (first (:errors error-response))
                             (get-translation "testset.set-parameters.load-error" "Error loading parameters"))]
      {:db       (update db :progress disj ::load-params)
       :dispatch [::notifications/error2 error-message {:auto-close true}]})))

(re-frame/reg-event-db
  ::set-param-value
  (fn [db [_ param-name value]]
    (assoc-in db [:form-states2 state-key :param-values param-name] value)))

(re-frame/reg-event-fx
  ::apply-params
  (fn [{:keys [db]} _]
    (if (contains? (:progress db) ::apply-params)
      {}
      (let [state        (get-in db [:form-states2 state-key])
            selection    (:selection state)
            testset-id   (:testset-id state)
            param-values (:param-values state)]
        {:db (-> db
                 (update :progress conj ::apply-params)
                 (assoc-in [:form-states2 state-key :apply-error] nil))
         :http-xhrio
         {:method          :put
          :uri             (broutes/get-url "steps_params#update"
                                            {:project_id (subs/get-current-project-id db)
                                             :id         testset-id})
          :params          {:step_param_names param-values
                            :ids             (ids->str selection)
                            :set_id          testset-id}
          :format          (ajax/json-request-format)
          :response-format (ajax/json-response-format {:keywords? true})
          :on-success      [::params-applied]
          :on-failure      [::params-apply-error]}}))))

(re-frame/reg-event-fx
  ::params-applied
  (fn [{:keys [db]} _]
    {:db       (update db :progress disj ::apply-params)
     :dispatch-n [[::hide-modal]
                  [::notifications/success2
                   (get-translation "testset.set-parameters.success" "Parameters updated successfully.")
                   {:auto-close true}]
                  [::testset-events/fetch-instances]]}))

(re-frame/reg-event-fx
  ::params-apply-error
  (fn [{:keys [db]} [_ error]]
    (let [error-response (get-in error [:response])
          error-message  (or (:error error-response)
                             (first (:errors error-response))
                             (get-translation "testset.set-parameters.error" "Error updating parameters."))]
      {:db (-> db
               (update :progress disj ::apply-params)
               (assoc-in [:form-states2 state-key :apply-error] error-message))})))

(re-frame/reg-sub
  ::show-modal?
  (fn [db _] (get-in db [:form-states2 state-key :show-modal?])))

(re-frame/reg-sub
  ::params
  (fn [db _] (get-in db [:form-states2 state-key :params] [])))

(re-frame/reg-sub
  ::param-values
  (fn [db _] (get-in db [:form-states2 state-key :param-values] {})))

(re-frame/reg-sub
  ::batch-name
  (fn [db _] (get-in db [:form-states2 state-key :batch-name])))

(re-frame/reg-sub
  ::instance-ids
  (fn [db _] (get-in db [:form-states2 state-key :instance-ids])))

(re-frame/reg-sub
  ::loading?
  (fn [db _] (contains? (:progress db) ::load-params)))

(re-frame/reg-sub
  ::applying?
  (fn [db _] (contains? (:progress db) ::apply-params)))

(re-frame/reg-sub
  ::apply-error
  (fn [db _] (get-in db [:form-states2 state-key :apply-error])))

(re-frame/reg-sub
  ::enterprise-only?
  (fn [db _] (get-in db [:form-states2 state-key :enterprise-only?])))

(defn- param-row [{:keys [name type possible_vals]} param-values]
  [:div.form-group
   [:label name]
   (if (contains? #{"list" "url_list"} type)
     [selector2/new-select
      {:items       possible_vals
       :value       (let [v (get param-values name "")]
                      (when (not= v "") v))
       :label-fn    identity
       :key-fn      identity
       :placeholder (get-translation "generic.select-a-value" "Select a Value")
       :on-change   (fn [v] (re-frame/dispatch [::set-param-value name v]))}]
     [:input.form-control
      {:type        "text"
       :value       (get param-values name "")
       :on-change   #(re-frame/dispatch [::set-param-value name (-> % .-target .-value)])}])])

(defn set-instance-parameters-modal []
  (let [show?            @(re-frame/subscribe [::show-modal?])
        params           @(re-frame/subscribe [::params])
        param-values     @(re-frame/subscribe [::param-values])
        batch-name       @(re-frame/subscribe [::batch-name])
        instance-ids     @(re-frame/subscribe [::instance-ids])
        loading?         @(re-frame/subscribe [::loading?])
        applying?        @(re-frame/subscribe [::applying?])
        apply-error      @(re-frame/subscribe [::apply-error])
        enterprise-only? @(re-frame/subscribe [::enterprise-only?])]
    [modal/bootstrap-modal
       {:is-open?         show?
        :on-request-close #(re-frame/dispatch [::hide-modal])
        :close-button?    false
        :centered?        true
        :class            "set-instance-parameters-modal"}
     
       [:div.set-params-header
        [:div.set-params-header__title
         [:span [icons/mux-pencil]]
         (get-translation "testset.instances.set-parameters" "Set Parameters")]
        (when batch-name
          [:p.text-center.mb-0
           {:title batch-name} 
           batch-name])]

       [:div

        (cond
          loading?
          [:div.text-center.py-4
           [spinners/mux-spinner {}]]

          enterprise-only?
          [:div.text-center.py-4.set-params-no-params
           (get-translation "testset.set-parameters.enterprise-only"
                            "Step Parameters are available on Enterprise plans only.")]

          (empty? params)
          [:div.text-center.py-4.set-params-no-params
           {:title (format-translation
                    (get-translation "testset.set-parameters.no-params"
                                     "The selected instances %{instance-ids} do not contain any step parameters.")
                    :instance-ids instance-ids)}
           (format-translation
            (get-translation "testset.set-parameters.no-params"
                             "The selected instances %{instance-ids} do not contain any step parameters.")
            :instance-ids instance-ids)]

          :else
          [:div
           (for [{:keys [name] :as param} params]
             ^{:key name}
             [param-row param param-values])])

        [:div.d-flex.justify-content-center.gap-3
         [buttons/button
          {:on-click #(re-frame/dispatch [::hide-modal])
           :text     (get-translation "generic.button.cancel" "Cancel")}]
         [buttons/button
          {:on-click  #(re-frame/dispatch [::apply-params])
           :primary?  true
           :disabled? (or applying? loading? (empty? params) enterprise-only?)
           :icon      (when applying? [spinners/mux-spinner {:size :small}])
           :text      (get-translation "generic.button.update" "Update")}]]]

       (when (and (not loading?) (not enterprise-only?))
         (if apply-error
           [:div.alert.alert-danger.text-center.mb-0
            apply-error]
           [:div.alert.alert-info.text-center.mb-0
            (get-translation "testset.set-parameters.info"
                             "You will update step-parameters for those instances which have tests with the above selected parameters.")]))]))

